/* eslint-disable no-console */
import toast from "react-hot-toast";
import { client } from "."; // ← cliente oficial

export const saveUsuario = async (usuario) => {
  try {
    // Normalizar rol a minúscula: la app nunca debe escribir roles con mayúsculas (defensa en profundidad)
    const usuarioNorm =
      typeof usuario?.rol === "string" ? { ...usuario, rol: usuario.rol.trim().toLowerCase() } : usuario;
    const { data, error } = await client.from("usuarios").insert(usuarioNorm).select();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error("Error saveUsuario:", error);
    toast.error("Error al crear usuario");
    throw error;
  }
};
